import { viewsetActions } from '@/service/plugin';

export default {
  subscriptions: viewsetActions('subscriptions', { basePath: '/api/s/' }),
};
